import { IStyle } from '@fluentui/react';
import { CommonStyles, FontSizes, FontWeights, IH2OTheme, Sizes } from '@h2oai/ui-kit';

export interface IFeatureSetMetaDataFieldsStyles {
  root?: IStyle;
  panel?: IStyle;
  title?: IStyle;
  fieldGroup?: IStyle;
  fields?: IStyle;
  field?: IStyle;
  label?: IStyle;
  value?: IStyle;
  emptyFieldGroup?: IStyle;
}

export interface IFeatureSetMetaDataFieldsClassNames {
  root?: string;
  panel?: string;
  title?: string;
  fieldGroup?: string;
  fields: string;
  field: string;
  label: string;
  value: string;
  emptyFieldGroup: string;
}

export const featureSetMetaDataFieldsStylesDefault = (theme: IH2OTheme): Partial<IFeatureSetMetaDataFieldsStyles> => ({
  root: {
    flex: 1,
    minHeight: 0,
    marginTop: 16,
    overflow: 'auto',
  },
  panel: { marginBottom: 16 },
  title: {
    fontSize: FontSizes.small,
    fontWeight: FontWeights.bold,
    marginBottom: 16,
  },
  fieldGroup: {
    marginTop: 12,
    padding: '24px 32px',
    display: 'flex',
    border: `1px solid ${theme.palette?.gray300}`,
    borderRadius: Sizes.borderRadius,
    backgroundColor: theme.palette?.white,
    minHeight: 100,
    '&.is-tag': {
      display: 'block',
      paddingRight: 16,
      paddingBottom: 8,
    },
  },
  emptyFieldGroup: {
    flex: 1,
    textAlign: 'center',
    lineHeight: 50,
  },
  fields: {
    width: 300,
    marginRight: 40,
    paddingRight: 40,
    borderRight: `1px solid ${theme.palette?.gray300}`,
    '&:last-child': {
      marginRight: 0,
      borderRight: 0,
    },
  },
  field: {
    marginBottom: 16,
    fontSize: FontSizes.xsmall,
    display: 'flex',
    justifyContent: 'space-between',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  label: { flex: 1, lineHeight: 17, ...CommonStyles.truncateString },
  value: { lineHeight: 17, fontWeight: FontWeights.semiBold, textTransform: 'capitalize' },
});
